// extracted by mini-css-extract-plugin
export default {"ClientDetail":"ClientDetail_ClientDetail__LyRH6","tableResponsive":"ClientDetail_tableResponsive__b75GY"};